module.exports = __webpack_public_path__ + "static/img/dc_step_activebg.ac097c78.png";